import { render } from "./colour-swatches.vue?vue&type=template&id=b95b65ba"
import script from "./colour-swatches.vue?vue&type=script&lang=js"
export * from "./colour-swatches.vue?vue&type=script&lang=js"

import "./colour-swatches.vue?vue&type=style&index=0&id=b95b65ba&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__